(function ($, Drupal, drupalSettings, once) {
  'use strict';

  Drupal.behaviors.tabbedPods = {
    tabPodInit: function (tabContents) {
      $(tabContents).slice(1).css('height', '0');
      $(tabContents).hide();
      $(tabContents).first().show();
    },

    tabPodSelect: function (tabs, tabContents) {
      $('.field--name-field-tabs > .field__item > .tab-contents').css('height', 'auto');
      $(tabs).on('click', function () {
        var activeTabValue = $(this).attr('data-title');
        $(this).addClass('js-active');
        $(tabs).not(this).removeClass('js-active');
        var activeTabContent = $(this).parent().parent().parent().find('.field--name-field-tabs > .field__item > .tab-contents[data-title="' + activeTabValue + '"]');
        $(activeTabContent).show().addClass('js-active');
        $(tabContents).not(activeTabContent).hide().removeClass('js-active');
        var imagesToLoad = $(activeTabContent).find('img');
        Drupal.blazy.init.load(imagesToLoad);
        return activeTabValue;
      });
    },

    attach: function (context, settings) {
      $(once('tabbed-pods', '.paragraph--type--tabs', context)).each(function () {
        Drupal.behaviors.tabbedPods.tabPodInit($(this).find('.field--name-field-tabs > .field__item > .component-kr-tab'));
        Drupal.behaviors.tabbedPods.tabPodSelect($(this).find('.kr-partner-tab-paragraph-labels__container button[data-title]'), $(this).find('.field--name-field-tabs > .field__item > .component-kr-tab'));
      });
    }
  };

})(jQuery, Drupal, drupalSettings, once); // eslint-disable-line no-undef
